/** 24 hours */
export const MAX_BUNDLE_AGE_MS = 24 * 60 * 60 * 1000;
